import styled from 'styled-components';
import colors from 'constants/colors';
import spinner from "assets/animations/spinner.svg";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${colors.black2};

  @media only screen and (min-width: 767px) and (max-width: 1200px) {
    ${({ mobile }) => (mobile? `
      height: calc(100vh - 140px);
    `: null
    )};
  }

  @media only screen and (max-width: 767px) {
    ${({ mobile }) => (mobile? `
      height: calc(100vh - 125px);
    `: null
    )};
  }

`
export const MessageContainer = styled.div`
  height: calc(100% - 80px);
  overflow: auto;
  letter-spacing: 0.5px;

  ::-webkit-scrollbar { 
    width: 0 !important 
  }

  ::-moz-scrollbar {
    width: 0 !important; 
  }
  
  & > div {
    & > div:last-child {
      width: 10%;
      height: 100%;
      min-width: 25px;
      max-width: 38px;
      display: flex;
      align-items: center;
      justify-content: center;

    & > img {
        display: block;
        position: relative;
      }
    }
  }

  & > div:nth-child(odd) {
    background-color: ${colors.black5};

    & > div:last-child {
      background-color: ${colors.black2};
    }
  }

  & > div:nth-child(even) {
    background-color: ${colors.black2};

    & > div:last-child {
      background-color: ${colors.charcoal};
    }
  }

  .noMoreMessages {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 30px 0px;
    font-size: 12px;
    font-weight: 600;
    color: ${colors.dimGrey};
    background-color: ${colors.black2};

    ${(props)=> props.mobile? `display: none`: null};
  }

  @media only screen and (min-width: 767px) and (max-width: 1200px) {
    ${({ mobile }) => (mobile? `
      height: calc(100vh - 220px);
    `: null
    )};
  }

  @media only screen and (max-width: 767px) {
    ${({ mobile }) => (mobile? `
      height: calc(100vh - 205px);
    `: null
    )};
  }
`;


export const Spinner = styled.div`
  position: relative;
  width: 100%;
  height: 50px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url(${spinner});
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  pointer-events: none;
`;
